import React from 'react';


function TableForm () {
    return (
        <div className='style1'>
           Статусный калькулятор (v.1.2)
        </div>
    )
}
export default TableForm
